/* eslint-disable indent */
export default [
  {
    title: "首页",
    link: "home",
    key: "home",
    cur: "-1",
    icon: "bank",
  },
  {
    title: "案件管理",
    link: "newlylist",
    key: "debtor:view",
    cur: "0",
    icon: "profile",
  },
  {
    title: "分期管理",
    link: "payback",
    key: "loan:lists",
    cur: "1",
    icon: "apartment",
  },
  {
    title: "案款管理",
    link: "collectionAmount",
    key: "payee:lists",
    cur: "Z",
    icon: "transaction",
  },
  {
    title: "案件委托",
    link: "entrust",
    key: "entrust:agent,management:manage",
    cur: "W",
    icon: "pull-request",
    child: [
      {
        title: "委托代理",
        link: "entrust",
        key: "entrust:agent",
        cur: "W-0",
        icon: "pull-request",
        icon1: "pull-request",
      },
      {
        title: "委托管理",
        link: "management",
        key: "management:manage",
        cur: "W-1",
        icon: "pull-request",
        icon1: "pull-request",
      },
    ],
  },
  {
    title: "案件反馈",
    link: "Infomation",
    key: "Infomation:lists",
    cur: "Y",
    icon: "file-sync",
  },
  // {
  //   title: '委托管理',
  //   link: null,
  //   key: 'debtor:view',
  //   cur: "X"
  // },
  {
    title: "档案管理",
    link: "letters",
    key: "test",
    // key: 'letters:view',
    cur: "L",
    icon: "global",
    child: [
      {
        title: "律师函件",
        link: "letters",
        key: "test",
        //   key: 'letters:view',
        cur: "L",
      },
    ],
  },
  // {
  //   title: '档案管理',
  //   link: 'letters',
  //   key: 'letters:lists',
  //   cur: 'L'
  // },
  {
    title: "统计管理",
    link: "litigationStatistics",
    other: true,
    key: "statis:cause,statis:statistics:lists,statis:addCount:lists,statis:loan:lists,statis:cancel:lists",
    cur: "4-0",
    icon: "snippets",
    child: [
      {
        title: "案件统计",
        link: "litigationStatistics",
        key: "statis:cause",
        other: true,
        cur: "4-0",
      },
      {
        title: "法院统计",
        link: "caseStatistics",
        other: true,
        key: "statis:statistics:lists",
        cur: "4-1",
      },
      // {
      //   title: '标的及费用统计',
      //   link: 'costStatistics',
      //   key: '4-2'
      // },
      {
        title: "新增统计",
        link: "Analysis",
        key: "statis:addCount:lists",
        other: true,
        cur: "4-3",
      },
      {
        title: "案款统计",
        link: "Anclear",
        cur: "4-5",
        key: "statis:loan:lists",
        other: true,
      },
      {
        title: "分期统计",
        link: "Stages",
        key: "statis:credit:lists",
        other: true,
        cur: "4-6",
      },
      {
        title: "开庭统计",
        link: "openHall",
        key: "statis:openHall:lists",
        other: true,
        cur: "4-7",
      },
      {
        title: "文书统计",
        link: "referee",
        key: "statis:referee:lists",
        other: true,
        cur: "4-8",
      },
      {
        title: "费用统计",
        link: "causeFee",
        key: "statis:causeFee:lists",
        other: true,
        cur: "4-9",
      },
      {
        title: "进度统计",
        link: "stepStatistics",
        key: "statis:step:lists",
        other: true,
        cur: "4-10",
      },
      {
        title: "作废统计",
        link: "nullify",
        key: "statis:cancel:lists",
        other: true,
        cur: "4-4",
      },
    ],
  },
  {
    title: "基础管理",
    link: "directoryManage",
    key: "court:list,accsuer:index,team:index,over:index,car:index,reason:index",
    cur: "3-0",
    other: true,
    child: [],
    icon: "paper-clip",
  },
];
